import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

const CopyIdCell = ({ id }) => {
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!copied) {
            return undefined;
        }
        const timeoutId = setTimeout(() => setCopied(false), 1600);
        return () => clearTimeout(timeoutId);
    }, [copied]);

    const handleCopy = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!id) {
            return;
        }
        try {
            await navigator.clipboard.writeText(String(id));
            setCopied(true);
        } catch (_) {
            // Clipboard access can fail on insecure origins; leave the ID selectable.
        }
    };

    if (!id) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                minWidth: 0,
                width: '100%',
            }}
        >
            <span
                style={{
                    userSelect: 'all',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
            >
                {id}
            </span>
            <Tooltip
                title={copied ? 'Copied!' : 'Copy to clipboard'}
                placement="top"
            >
                <IconButton
                    size="small"
                    onClick={handleCopy}
                    aria-label="Copy ID to clipboard"
                    sx={{
                        color: 'var(--link-color)',
                        padding: '2px',
                        flexShrink: 0,
                    }}
                >
                    {copied ? (
                        <CheckIcon sx={{ fontSize: 16 }} />
                    ) : (
                        <ContentCopyIcon sx={{ fontSize: 16 }} />
                    )}
                </IconButton>
            </Tooltip>
        </Box>
    );
};

CopyIdCell.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CopyIdCell;
